// extracted by mini-css-extract-plugin
module.exports = {"tags":"SeasonItem__tags___1ztif","tagWrapper":"SeasonItem__tagWrapper___2bM30"};